import { Navigate, RouteObject } from 'react-router-dom';

/**
 * Route children for the PR Compliance section.
 * Mounted under `/eval/pr-compliance/*` from `src/eval/routes.tsx`.
 *
 * Scheduling and comparison both reuse the canonical eval pages with a
 * `solution=pr_compliance` query param so the form/comparison switches into
 * PR-Compliance mode. These routes are kept as stable deep-links.
 */
export const prCompRoutes: RouteObject[] = [
  {
    path: 'pr-compliance',
    element: <Navigate to="/eval/runs/new?solution=pr_compliance" replace />,
  },
  {
    path: 'pr-compliance/runs/new',
    element: <Navigate to="/eval/runs/new?solution=pr_compliance" replace />,
  },
];
